const expandedInsideBorderSize = 0;
const collapsedInsideBorderSize = 4;
const collapsedOutsideBorderSize = 4;
const collapsedWidth = 25;

let thumbnailLocation = '';
const getThumbnailLocation = (flag: string) => {
  thumbnailLocation = flag;
};

const getPanelGroupDefinition = ({
  leftPanelInitialExpandedWidth = 282,
  rightPanelInitialExpandedWidth = 280,
  leftPanelMinimumExpandedWidth = 145,
  rightPanelMinimumExpandedWidth = 280,
}) => {
  return {
    groupId: 'viewerLayoutResizablePanelGroup',
    shared: {
      expandedInsideBorderSize,
      collapsedInsideBorderSize,
      collapsedOutsideBorderSize,
      collapsedWidth,
    },
    left: {
      // id
      panelId: 'viewerLayoutResizableLeftPanel',
      // expanded width
      initialExpandedWidth: thumbnailLocation === 'top' ? '100%' : 300,
      // expanded width + expanded inside border
      minimumExpandedOffsetWidth: 145 + expandedInsideBorderSize,
      // initial expanded width
      initialExpandedOffsetWidth: leftPanelInitialExpandedWidth + expandedInsideBorderSize,
      // collapsed width + collapsed inside border + collapsed outside border
      collapsedOffsetWidth: collapsedWidth + collapsedInsideBorderSize + collapsedOutsideBorderSize,
    },
    right: {
      panelId: 'viewerLayoutResizableRightPanel',
      initialExpandedWidth: thumbnailLocation === 'top' ? '100%' : 300,
      minimumExpandedOffsetWidth: 145 + expandedInsideBorderSize,
      initialExpandedOffsetWidth: rightPanelInitialExpandedWidth + expandedInsideBorderSize,
      collapsedOffsetWidth: collapsedWidth + collapsedInsideBorderSize + collapsedOutsideBorderSize,
    },
  };
};

export { getPanelGroupDefinition, getThumbnailLocation };
